module.exports = __webpack_public_path__ + "img/product-circle.8fe8982b.svg";